// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 2H8V5H5V9H19V5H16V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 11H22V22H16V16H8V22H2V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V18H14V22H10Z"}}]};

const Building3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-3-filled',
    ref,
    icon: element,
  },
));

Building3FilledIcon.displayName = 'Building3FilledIcon';

export default Building3FilledIcon;
